import { useSettingsStore } from '../store/settingsStore'
import { themes, GAME_COLORS, type Theme } from '../design/premiumTokens'

/**
 * Hook to access current theme colors.
 *
 * Returns:
 * - Theme colors (change based on theme selection): primary, background, card, text, artists, etc.
 * - Game mechanic constants (never change): auctionTypes, status
 *
 * Note: Artist colors now change with each theme - each theme has a unique 5-color palette!
 *
 * @example
 * const theme = useTheme()
 * <div style={{ color: theme.primary }}>Hello</div>
 * <div style={{ background: theme.artists['Solstice Vane'].gradient }}>Artist Badge</div>
 * <div style={{ background: theme.auctionTypes.open }}>Auction Type</div>
 */
export function useTheme() {
  const { theme } = useSettingsStore()
  // Fallback to 'classic' if the theme doesn't exist (handles migration from old theme names)
  const currentTheme = themes[theme as keyof typeof themes] || themes.classic

  return {
    // All theme colors including unique artist palettes for this theme
    ...currentTheme,

    // Game mechanic constants (never change)
    auctionTypes: GAME_COLORS.auctionTypes,
    status: GAME_COLORS.status,
  }
}
